import React from 'react'
import { css } from 'emotion'
import * as images from 'images'

const RewardsLeftArrowButtonView = ({ disabled }) => (
  <img
    className={styles.leftArrow}
    src={images.rewardArrowLeft}
    style={disabled ? { opacity: 0.5 } : {}}
    alt="Left Arrow"
  />
)

const styles = {
  leftArrow: css({
    position: 'absolute',
    top: '43%',
    left: '.9rem',
    transition: 'all .2s',
    '&:hover': {
      transform: 'translateX(-1px)',
    },
    '&:active': {
      transform: 'translate(1px, .5px)',
    },
  }),
}

export default RewardsLeftArrowButtonView
